import {superAdminLoginAction, clearSuperAdminLoginAction} from '../slices/SuperAdminLogin';
import {createTenantUserAction, clearCreateTenantUserAction} from '../slices/createTenantUser';
import {getAllTenantUserAction, clearGetAllTenantUserAction} from '../slices/getAllTenantUser';
import { updateTenantAction, clearUpdateTenantAction } from '../slices/updateTenantAdmin';
import {updateTenantUserAction,clearUpdateTenantUserAction} from '../slices/updateTenantUser';
import {updateTenantUserPasswordAction, clearUpdateTenantUserPasswordAction} from '../slices/updateTenantUserPassword';
import {updateTenantUserStatusAction, clearUpdateTenantUserStatusAction} from '../slices/updateTenantUserStatus';
import {createCropAction, clearCreateCropAction} from '../slices/createCrop';
import {getByCropAction, clearGetByCropAction} from '../slices/getByCrop';
import { getAllCropsAction,clearGetAllCropsAction} from '../slices/getAllCrop';
import {updateCropAction,clearUpdateCropAction} from '../slices/updateCrop';

import {createVarietyAction,clearCreateVarietyAction} from '../slices/createVariety';
import {getByVarietyAction,clearGetByVarietyAction} from '../slices/getByVariety';
import {getAllVarietiesAction, clearGetAllVarietiesAction } from '../slices/getAllVariety';
import { updateVarietyAction,clearUpdateVarietyAction} from '../slices/updateVariety';

import { getAllTenantsAction,clearGetAllTenantsAction } from '../slices/getAllTenants';
import { createUserAction,clearCreateUserAction } from '../slices/createUser';
import { getAllUserAction, clearGetAllUserAction } from '../slices/getAllUsers';
import { tenantLoginAction, clearTenantLoginAction } from '../slices/tenantLogin';
import { createZoneAction,clearCreateZoneAction } from '../slices/createZone';
import { getAllZonesAction,clearGetAllZonesAction } from '../slices/getAllZones';
import { getZoneByIdAction, clearGetZoneByIdAction } from '../slices/getZoneById';
import { updateZoneAction, clearUpdateZoneAction } from '../slices/updateZone';
import { getUserByIdAction, clearGetUserByIdAction } from '../slices/getUserById';
import { createRegionAction, clearCreateRegionAction } from '../slices/createRegions';
import { getAllRegionsAction, clearGetAllRegionsAction } from '../slices/getAllRegions';
import { getRegionByIdAction, clearGetRegionByIdAction } from '../slices/getRegionById';
import { updateRegionAction, clearUpdateRegionAction } from '../slices/updateRegion';
import { createAreaAction, clearCreateAreaAction } from '../slices/createArea';
import { getAllAreasAction, clearGetAllAreasAction } from '../slices/getAllAreas';
import { getAreaByIdAction, clearGetAreaByIdAction } from '../slices/getAreaById';
import { updateAreaAction, clearUpdateAreaAction } from '../slices/updateArea';
import { createDistrictAction, clearCreateDistrictAction } from '../slices/createDistrict';
import { getAllDistrictsAction, clearGetAllDistrictsAction } from '../slices/getAllDistrict';
import { getDistrictByIdAction, clearGetDistrictByIdAction } from '../slices/getDistrictById';
import { updateDistrictAction, clearUpdateDistrictAction } from '../slices/updateDistricts';
import { createMandalAction, clearCreateMandalAction } from '../slices/createMandal';
import { getAllMandalsAction, clearGetAllMandalsAction } from '../slices/getAllMandals';
import { getMandalByIdAction, clearGetMandalByIdAction } from '../slices/getMandalById';
import { updateMandalAction, clearUpdateMandalAction } from '../slices/updateMandal';
import { createVillageAction, clearCreateVillageAction } from '../slices/createVillage';
import { getAllVillagesAction, clearGetAllVillagesAction } from '../slices/getAllVillages';
import { getVillageByIdAction, clearGetVillageByIdAction } from '../slices/getVillageById';
import { updateVillageAction, clearUpdateVillageAction } from '../slices/updateVillage';
import { createDealerAction, clearCreateDealerAction } from '../slices/createDealer';
import { getAllDealersAction, clearGetAllDealersAction } from '../slices/getAllDealers';
import { getDealerByIdAction, clearGetDealerByIdAction } from '../slices/getDealerById';
import { updateDealerAction, clearUpdateDealerAction } from '../slices/updateDealer';
import { getAllSeasonsAction,clearGetAllSeasonsAction} from '../slices/getAllSeasons';
import { createSeasonAction, clearCreateSeasonAction } from '../slices/createSeason';
import {updateSeasonAction, clearUpdateSeasonAction } from '../slices/updateSeason';
import { createFarmerAction,clearCreateFarmerAction} from '../slices/createFormer';
import {getAllFarmersAction,clearGetAllFarmersAction} from '../slices/getAllFarmers';
import {updateFarmerAction,clearUpdateFarmerAction} from '../slices/updateFarmer';
import { getAllSalesTargetsAction, clearGetAllSalesTargetsAction } from '../slices/getAllSalesTargets';
import { getSalesTargetByIdAction, clearGetSalesTargetByIdAction } from '../slices/getSalesTargetById';
import { updateSalesTargetAction, clearUpdateSalesTargetAction } from '../slices/updateSalesTarget';
import { createSalesTargetAction, clearCreateSalesTargetAction } from '../slices/createSalesTarget';
import { createPreSeasonActivityAction,clearCreatePreSeasonActivityAction} from '../slices/createPreSeasonActivity';
import { getAllPreSeasonActivitiesAction,clearGetAllPreSeasonActivitiesAction } from '../slices/getAllPreSeasonActivities';
import { getPreSeasonActivityByIdAction,clearGetPreSeasonActivityByIdAction} from '../slices/getPreSeasonActivitiyById';
import { updatePreSeasonActivityAction, clearUpdatePreSeasonActivityAction } from '../slices/updatePreSeasonActivity';
import { updatePostSeasonActivityAction, clearUpdatePostSeasonActivityAction } from '../slices/updatePostSeasonActivity';
import { getPostSeasonActivityByIdAction, clearGetPostSeasonActivityByIdAction } from '../slices/getPostSeasonActivityById';
import { createPostSeasonActivityAction, clearCreatePostSeasonActivityAction } from '../slices/createPostSeasonActivity';
import { getAllPostSeasonActivitiesAction,clearGetAllPostSeasonActivitiesAction } from '../slices/getPostSeasonActivity';
import { createFarmerCommitmentAction, clearCreateFarmerCommitmentAction } from '../slices/createFarmerCommitment';
import { getAllFarmerCommitmentsAction, clearGetAllFarmerCommitmentsAction } from '../slices/getAllFarmerCommitment';
import { getFarmerCommitmentByIdAction, clearGetFarmerCommitmentByIdAction } from '../slices/getFarmerCommitmentById';
import { updateFarmerCommitmentAction, clearUpdateFarmerCommitmentAction } from '../slices/updateFarmerCommitment';
import { farmerCommitmentAction,clearfarmerCommitmentAction } from '../slices/farmerCommitment';
import { createMonthlyTargetAction,clearCreateMonthlyTargetAction } from '../slices/createMonthlyTarget';
import { getAllMonthlyTargetsAction, clearGetAllMonthlyTargetsAction } from '../slices/getAllMonthlyTargets';
import { createActivityAction,clearCreateActivityAction } from '../slices/createActivity';
import { getActivityByIdAction, clearGetActivityByIdAction } from '../slices/getActivitiesById';
import { updateActivityAction, clearUpdateActivityAction } from '../slices/updateActivites';
import { getAllActivitiesAction, clearGetAllActivitiesAction } from '../slices/getAllActivities';
import { createPostMonthlyTargetAction, clearCreatePostMonthlyTargetAction } from '../slices/createMonthlyTargetPost';
import { getAllPostMonthlyTargetsAction,clearGetAllPostMonthlyTargetsAction } from '../slices/getAllPostMonthlyTargets';
import { createPostActivityAction, clearCreatePostActivityAction } from '../slices/createPostActivity';
import { getAllPostActivitiesAction, clearGetAllPostActivitiesAction } from '../slices/getAllPostActivity';
import { getPostActivityByIdAction, clearGetPostActivityByIdAction } from '../slices/getPostActivityById';
import { updatePostActivityAction, clearUpdatePostActivityAction } from '../slices/updatePostActivity';
import { getAllMediaFilesAction,clearGetAllMediaFilesAction} from "../slices/getAllMeadiaFiles";
import {getAllPostMediaFilesAction,clearGetAllPostMediaFilesAction,} from "../slices/getAllPostMeadiaFiles"
import { createDailyPunchAction, clearCreateDailyPunchAction } from '../slices/createPunchingLog';
import { getAllDailyPunchesAction, clearGetAllDailyPunchesAction } from '../slices/getAllpunchingLogs';
import { updateDailyPunchAction, clearUpdateDailyPunchAction } from '../slices/updatePunchingLog';
import { getDailyPunchByIdAction, clearGetDailyPunchByIdAction } from '../slices/getDailyPunchingLogByid';
import { createDailyTaskAction, clearCreateDailyTaskAction } from '../slices/createDailyTask';
import { getAllDailyTasksAction, clearGetAllDailyTasksAction } from '../slices/getAllDailyTask';
import { getDailyTaskByIdAction, clearGetDailyTaskByIdAction } from '../slices/getDailyTaskById';
import { updateDailyTaskAction, clearUpdateDailyTaskAction } from '../slices/updateDailyTask';
import { loginWithOTPAction, clearLoginWithOTPAction } from '../slices/loginWithOTP';
import { verifyOtpAction, clearVerifyOtpAction } from '../slices/verifyLoginOtp';
import { forgotPasswordAction, clearForgotPasswordAction } from '../slices/forgotPassword';
import { verifyForgotPasswordAction, clearVerifyForgotPasswordAction } from '../slices/verifyForgotPassword';
import { calculateSalesTargetAction, clearCalculateSalesTargetAction } from '../slices/calculateSalesTarget';

export {
    superAdminLoginAction,
    clearSuperAdminLoginAction,
    createTenantUserAction,
    clearCreateTenantUserAction,
    getAllTenantUserAction,
    clearGetAllTenantUserAction,
    updateTenantAction,
    clearUpdateTenantAction,
    updateTenantUserAction,
    clearUpdateTenantUserAction,
    updateTenantUserPasswordAction,
    clearUpdateTenantUserPasswordAction,
    updateTenantUserStatusAction,
    clearUpdateTenantUserStatusAction,
    createCropAction,
    clearCreateCropAction,
    getByCropAction,
    clearGetByCropAction,
    getAllCropsAction,
    clearGetAllCropsAction,
    updateCropAction,
    clearUpdateCropAction,
    createVarietyAction,
    clearCreateVarietyAction,
    getByVarietyAction,
    clearGetByVarietyAction,
    getAllVarietiesAction,
    clearGetAllVarietiesAction,
    updateVarietyAction,
    clearUpdateVarietyAction,
    getAllTenantsAction,
    clearGetAllTenantsAction,
    createUserAction,
    clearCreateUserAction,
    getAllUserAction,
    clearGetAllUserAction,
    tenantLoginAction,
    clearTenantLoginAction,
    createZoneAction,
    clearCreateZoneAction,
    getAllZonesAction,
    clearGetAllZonesAction,
    getZoneByIdAction,
    clearGetZoneByIdAction,
    updateZoneAction,
    clearUpdateZoneAction,
    getUserByIdAction,
    clearGetUserByIdAction,
    createRegionAction,
    clearCreateRegionAction,    
    getAllRegionsAction,
    clearGetAllRegionsAction,
    getRegionByIdAction,
    clearGetRegionByIdAction,
    updateRegionAction,
    clearUpdateRegionAction,
    createAreaAction,
    clearCreateAreaAction,
    getAllAreasAction,
    clearGetAllAreasAction,
    getAreaByIdAction,
    clearGetAreaByIdAction,
    updateAreaAction,
    clearUpdateAreaAction,
    createDistrictAction,
    clearCreateDistrictAction,
    getAllDistrictsAction,
    clearGetAllDistrictsAction,
    getDistrictByIdAction,
    clearGetDistrictByIdAction,
    updateDistrictAction,
    clearUpdateDistrictAction,
    createMandalAction,
    clearCreateMandalAction,
    getAllMandalsAction,
    clearGetAllMandalsAction,
    getMandalByIdAction,
    clearGetMandalByIdAction,
    updateMandalAction,
    clearUpdateMandalAction,
    createVillageAction,
    clearCreateVillageAction,
    getAllVillagesAction,
    clearGetAllVillagesAction,
    getVillageByIdAction,
    clearGetVillageByIdAction,
    updateVillageAction,
    clearUpdateVillageAction,
    createDealerAction,
    clearCreateDealerAction,
    getAllDealersAction,
    clearGetAllDealersAction,
    getDealerByIdAction,
    clearGetDealerByIdAction,
    updateDealerAction,
    clearUpdateDealerAction,
    getAllSeasonsAction,
    clearGetAllSeasonsAction,
    createSeasonAction,
    clearCreateSeasonAction,
    updateSeasonAction,
    clearUpdateSeasonAction,
    createFarmerAction,
    clearCreateFarmerAction,
    getAllFarmersAction,
    clearGetAllFarmersAction,
    updateFarmerAction,
    clearUpdateFarmerAction,
    getAllSalesTargetsAction,
    clearGetAllSalesTargetsAction,
    getSalesTargetByIdAction,
    clearGetSalesTargetByIdAction,
    updateSalesTargetAction,
    clearUpdateSalesTargetAction,
    createSalesTargetAction,
    clearCreateSalesTargetAction,
    createPreSeasonActivityAction,
    clearCreatePreSeasonActivityAction,
    getAllPreSeasonActivitiesAction,
    clearGetAllPreSeasonActivitiesAction,
    getPreSeasonActivityByIdAction,
    clearGetPreSeasonActivityByIdAction,
    updatePreSeasonActivityAction,
    clearUpdatePreSeasonActivityAction,
    updatePostSeasonActivityAction,
    clearUpdatePostSeasonActivityAction,
    getPostSeasonActivityByIdAction,
    clearGetPostSeasonActivityByIdAction,
    createPostSeasonActivityAction,
    clearCreatePostSeasonActivityAction,
    getAllPostSeasonActivitiesAction,
    clearGetAllPostSeasonActivitiesAction,
    createFarmerCommitmentAction,
    clearCreateFarmerCommitmentAction,
    getAllFarmerCommitmentsAction,
    clearGetAllFarmerCommitmentsAction,
    getFarmerCommitmentByIdAction,
    clearGetFarmerCommitmentByIdAction,
    updateFarmerCommitmentAction,
    clearUpdateFarmerCommitmentAction,
    farmerCommitmentAction,
    clearfarmerCommitmentAction,
    createMonthlyTargetAction,
    clearCreateMonthlyTargetAction,
    getAllMonthlyTargetsAction,
    clearGetAllMonthlyTargetsAction,
    createActivityAction,
    clearCreateActivityAction,
    getActivityByIdAction,
    clearGetActivityByIdAction,
    updateActivityAction,
    clearUpdateActivityAction,
    getAllActivitiesAction,
    clearGetAllActivitiesAction,
    createPostMonthlyTargetAction,
    clearCreatePostMonthlyTargetAction,
    getAllPostMonthlyTargetsAction,
    clearGetAllPostMonthlyTargetsAction,
    createPostActivityAction,
    clearCreatePostActivityAction,
    getAllPostActivitiesAction,
    clearGetAllPostActivitiesAction,
    getPostActivityByIdAction,
    clearGetPostActivityByIdAction,
    updatePostActivityAction,
    clearUpdatePostActivityAction,
    getAllMediaFilesAction,
    clearGetAllMediaFilesAction,
    getAllPostMediaFilesAction,
    clearGetAllPostMediaFilesAction,
    createDailyPunchAction,
    clearCreateDailyPunchAction,
    getAllDailyPunchesAction,
    clearGetAllDailyPunchesAction,
    updateDailyPunchAction,
    clearUpdateDailyPunchAction,
    getDailyPunchByIdAction,
    clearGetDailyPunchByIdAction,
    createDailyTaskAction,
    clearCreateDailyTaskAction, 
    getAllDailyTasksAction,
    clearGetAllDailyTasksAction,
    getDailyTaskByIdAction,
    clearGetDailyTaskByIdAction,
    updateDailyTaskAction,
    clearUpdateDailyTaskAction,
    loginWithOTPAction,
    clearLoginWithOTPAction,
    verifyOtpAction,
    clearVerifyOtpAction,
    forgotPasswordAction,
    clearForgotPasswordAction,
    verifyForgotPasswordAction,
    clearVerifyForgotPasswordAction,
    calculateSalesTargetAction,
    clearCalculateSalesTargetAction,
}